<ng-container *ngIf="unsafeUrl$ | async as unsafeUrl">
  <div *ngIf="esImagen(unsafeUrl);else pdf" class="isIMG">
    <img [src]="url(unsafeUrl)" />
  </div>
  <!-- <ng-template #pdf>
    <ng-container *ngIf="!isSafari; else otro">
      <div class="mat-elevation-z6 isPDF">
        <object [data]="url(unsafeUrl)" type="application/pdf">
          <embed style="width: 100%; height: 100%;" [src]="url(unsafeUrl)" type="application/pdf" />
        </object>
      </div>
    </ng-container>
  </ng-template> -->
</ng-container>
<ng2-pdfjs-viewer *ngIf="visible" #pdfViewer (onDocumentLoad)="loaded($event)"></ng2-pdfjs-viewer>

